import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-7xl px-6 py-28 md:py-36">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="lg:col-span-5"
        >
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-brand-terra">
            Questions, Answered
          </p>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight md:text-5xl">
            Everything parents & students <em className="italic text-brand-terra">ask us</em>.
          </h2>
          <p className="mt-7 max-w-md text-base leading-relaxed text-brand-muted md:text-lg">
            Can't find your answer? Call us or drop a message on WhatsApp — a
            counsellor replies within 24 hours.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.15 }}
          className="lg:col-span-7"
        >
          {FAQS.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div key={faq.q} data-testid={`faq-item-${i}`} className="border-t border-brand-line last:border-b">
                <button
                  data-testid={`faq-trigger-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="group flex w-full items-center justify-between gap-6 py-6 text-left"
                >
                  <span className={`font-serif text-xl leading-snug transition-colors duration-300 md:text-2xl ${isOpen ? "text-brand-terra" : "text-brand-ink group-hover:text-brand-terra"}`}>
                    {faq.q}
                  </span>
                  <Plus
                    className={`h-5 w-5 shrink-0 text-brand-terra transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: EASE }}
                      className="overflow-hidden"
                    >
                      <p data-testid={`faq-answer-${i}`} className="max-w-2xl pb-7 text-sm leading-relaxed text-brand-muted md:text-base">
                        {faq.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
